import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, TextField, Button, Typography } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import { lookupFolio } from "./folioMatrixLogic";

const ETIQUETA_STATUS = {
  assigned: "Asignado",
  reserved: "Reservado/bloqueado",
  unassigned: "Libre",
};

export default function FolioSearchBox({ asignados, reservados, modalidades, onAbrirFolio }) {
  const [texto, setTexto] = useState("");
  const [resultado, setResultado] = useState(null);

  function buscar() {
    const numero = Number(texto);
    if (!texto || !Number.isFinite(numero)) {
      setResultado(null);
      return;
    }
    setResultado(lookupFolio(numero, asignados, reservados, modalidades));
  }

  return (
    <Box mb={3}>
      <Typography variant="subtitle1" gutterBottom>
        Buscar folio
      </Typography>
      <Box display="flex" alignItems="center" style={{ gap: 8 }}>
        <TextField
          type="number"
          label="Número de folio"
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && buscar()}
        />
        <Button variant="contained" color="primary" startIcon={<SearchIcon />} onClick={buscar}>
          Buscar
        </Button>
      </Box>

      {resultado && (
        <Box mt={2}>
          <Typography>
            Folio {resultado.numero}: <strong>{ETIQUETA_STATUS[resultado.status]}</strong>
            {" — "}
            {resultado.inRange
              ? `dentro del rango de "${resultado.modalidad.label}" (${resultado.modalidad.desde}–${resultado.modalidad.hasta})`
              : "fuera de cualquier rango de modalidad configurado"}
          </Typography>
          {resultado.inRange && (
            <Button size="small" onClick={() => onAbrirFolio(resultado.numero)}>
              Abrir folio {resultado.numero}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
}

FolioSearchBox.propTypes = {
  asignados: PropTypes.instanceOf(Set).isRequired,
  reservados: PropTypes.instanceOf(Set).isRequired,
  modalidades: PropTypes.array.isRequired,
  onAbrirFolio: PropTypes.func.isRequired,
};
